import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/laendergruppen/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="CountryGroup"
      returnRoute="/auswahlfelder/countryGroups"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const CountryGroupsRoute = Route;
